<div class="card-body m-4">
    <div [ngClass]="{ warningContainer: hideKey, keyContainer: !hideKey }">
        <div *ngIf="hideKey" class="warningContent">
            <div class="warningTitle">
                <b style="color: #E53838"> {{ "apiKey.warningTitle" | translate }}: </b>
                <span> {{ "apiKey.warningDescription" | translate }} </span>
            </div>
            <div>
                <a (click)="showWarning()" class="btn btn-primary" style="white-space: nowrap;">
                    {{ "apiKey.generateKey" | translate }}
                </a>
            </div>
        </div>
        <div *ngIf="!hideKey" class="keyContent">
            <div style="word-break: break-all; white-space: pre-line; margin: 4px;"  [ngClass]="{ cropKey: cropKey }">
                {{privateKey}}
            </div>
            <a (click)="toggleCropKey()" style="cursor: pointer;">
                <img [src]="seeKeyIcon" width="24px" style="margin: 4px;"/>
            </a>
            <a (click)="copyKey()" (mouseover)="copyHover(true)" (mouseleave)="copyHover(false)" style="cursor: pointer;">
                <img src="assets/identity/keyCopy.svg" width="24px" style="margin: 4px;" [ngClass]="{
                    copyHover: copyHovered,
                    copyActive: copyActive
                }"/>
                <div class="copyBanner" [ngClass]="{
                    copyHover: copyHovered,
                    copyActive: copyActive,
                    copyHidden: !copyHovered && !copyActive
                }">
                    {{ (copyActive ? "apiKey.copied" : "apiKey.copy") | translate }}
                </div>
            </a>
        </div>
    </div>
</div>
<ng-template #modalContent>
    <app-confirm-after-delay-modal 
        [title]="'apiKey.warningTitle' | translate"
        [description]="'apiKey.warningDescription' | translate"
        [confirmText]="'apiKey.warningConfirmButton' | translate"
        [cancelText]="'apiKey.warningCancelButton' | translate"
        (onConfirm)="generateKeys()"
        (onCancel)="closeWarning()"
        [timer]=5
    >     
    </app-confirm-after-delay-modal>
</ng-template>
